export const STORE_BUTTON_TYPES = {
    apple: 'apple',
    google: 'google',
}

export const STORE_BUTTON_CONFIG = {
    [STORE_BUTTON_TYPES.apple]: {
        iconName: 'IcAppStoreBadge',
        title: 'App Store',
        appStoreKeyName: 'appStoreLinkApple',
    },
    [STORE_BUTTON_TYPES.google]: {
        iconName: 'IcGooglePlayBadge',
        title: 'Google Play',
        appStoreKeyName: 'appStoreLinkGoogle',
    },
}